import { Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { CeCheckbox } from "../../generic/components/form-fields/ce-checkbox";
import { CeTextInput } from "../../generic/components/form-fields/ce-text-field";
import { FormStack } from "../../generic/components/form-fields/form-stack";

import type { EmailDesignSchema } from "../../email-design/types/email-design-type";
import type { FC } from "react";

export const TemplateDetailsEditor: FC = () => {
  const {
    formState: { defaultValues },
  } = useFormContext<EmailDesignSchema>();

  return (
    <FormStack>
      <CeTextInput<EmailDesignSchema> analyticsCategory="email_design" name="name" label="Name" />
      {defaultValues?.is_default ? (
        <Typography variant="overline" color="primary.main">
          Is Default
        </Typography>
      ) : (
        <CeCheckbox<EmailDesignSchema>
          analyticsCategory="email_design"
          name="is_default"
          label="Default"
        />
      )}
    </FormStack>
  );
};
